import Vue from 'vue';

export function getProvidersFromMedications(allData,medications) {
  let result = [];
  medications.forEach((medication)=>{
    let medicationRecord = allData.medications[medication];
    if(medicationRecord.npi)
      result.push(medicationRecord.npi)
  });
  return result;
}

export function getProvidersFromProcedures(allData,procedures) {
  let result = [];
  procedures.forEach((procedure)=>{
    if(procedure === 0)
      return;
    let procedureRecord = allData.procedures[procedure];
    if(procedureRecord.npi)
      result.push(procedureRecord.npi)
  });
  return result;
}

export function getProviderCitationsByNpi(allData, npi) {
  if (!allData) throw 'allData is null';
  const citationData = allData.citations[npi];
  return citationData;
}

export function getProviderByNpi(allData, npi) {
  if (!allData) throw 'allData is null';
  const npiData = allData.npis[npi];
  let provider = {};
  let bio = npiData.ao || npiData.pr || npiData.ot || null;

  if (bio) {
    provider.prefix = bio.pfx ? bio.pfx : '';
    provider.firstName = bio.fst ? bio.fst : '';
    provider.middleName = bio.mdl ? bio.mdl : '';
    provider.lastName = bio.lst ? bio.lst : '';
    provider.suffix = bio.sfx ? bio.sfx : '';
    provider.title = bio.crdntl ? bio.crdntl : '';
    provider.fullDesc = `${bio.lst}, ${bio.fst} ${(bio.mdl)?(bio.mdl+' '):''}${bio.crdntl}`;    // either degree (sfx) or title (crdntl)
  }
  provider.id = npi;
  provider.npi = npiData.npi;
  provider.affiliation = npiData.prorgnm;
  provider.gender = npiData.gndr;
  provider.phone = npiData.phone;
  provider.fax = npiData.fax;
  provider.address1 = npiData.address1;
  provider.address2 = npiData.address2;
  provider.city = npiData.city;
  provider.state = npiData.state;
  provider.zip = npiData.zip;
  provider.specialties = getProviderSpecialtiesByNpi(allData, npi);

  return provider;
}

export function getProviderSpecialtiesByNpi(allData, npi) {
  const npiData = allData.npis[npi];
  let specialties = [];

  // console.log(allData)
  // console.log(npi)
  // console.log(npiData)

  // specialties
  npiData.lic.forEach(lic => {
    if(lic.taxonomy)
    {
      specialties.push({
        id: lic.taxonomy,
        name: allData.taxonomies[lic.taxonomy].specialOrClassName
      })
    }
  });

  return specialties;
}

export function getReportsByNpi(allData, npi) {
  let reportList = [];
  if (allData && allData.reports) {
    allData.reports.forEach(report => {
      if (report.npi == npi) {
        reportList.unshift(
            {
              id:report.id,
              // displayName: `${report.when} @ ${getProviderByNpi(allData,report.npi).fullDesc}` ,
              date: report.when,
              documentType: allData.ccds[report.category].desc,
              procedure: report.ccdDescription,
            });
      }
    });
  }

  return reportList;
}
